import { messagesJP } from './lib/intl/ja';
import { Options } from '@sheerid/jslib';
import { RecursivePartial } from './lib/types/types';


export const programId = '60a68a133c42ee0a8b0e063b';

export const defaultOptions: RecursivePartial<Options> = {
    restApi: {
        serviceUrl: 'https://services.sheerid.com',
    },
    logLevel: 'error',
    useFingerprinting: true,
    messagesWithLocale: {
        ja: messagesJP,
    },
    privacyPolicyUrl: 'https://www.sheerid.com/privacy_notice_services_japanese/',
};
